export const shareManagerConstants = {
    CHANGE_SLIDE_MODAL_OPEN_STATE: "CHANGE_SLIDE_MODAL_OPEN_STATE",
    CHANGE_CASE_MODAL_OPEN_STATE: "CHANGE_CASE_MODAL_OPEN_STATE",
    ADD_SLIDES_TO_SHARE: "ADD_SLIDES_TO_SHARE",
    ADD_CASES_TO_SHARE: "ADD_CASES_TO_SHARE",
    CHANGE_LINK_EXPIRATION: "CHANGE_LINK_EXPIRATION",
    REMOVE_LINK_EXPIRATION: "REMOVE_LINK_EXPIRATION"
}
